import COS from "cos-js-sdk-v5"; // 腾讯云对象存储
import { viteCosBucket } from '@/utils/http.js';
import http from '@/utils/http'
let cacheList = [];
let status = false;
/* 默认COS桶中 */
export const defaultBucket = viteCosBucket;
export const defaultRegion = "ap-guangzhou"; // 默认桶所在区域

/** 防止重复请求获取临时秘钥的接口 */
async function setAuthorization() {
	if (status) {
		return new Promise(resolve => {
			cacheList.push((data) => {
				resolve(data);
			});
		});
	} else {
		status = true;
		let formData = new FormData();
		formData.append('api', 'kc/app/cTrain/cosKey');
		return http({
			url: '/ipd/commonApi',
			method: 'post',
			// form-data
			data: formData
		}).then((res) =>{
			cacheList.forEach((item) => {
				item(res);
			});
			cacheList = [];
			status = false;
			return res;
		})
	}
}
/* 新创建一个存储桶COS */
const cos = new COS({
	getAuthorization: async (options, callback) => {
		const res = await setAuthorization();
		callback({
			TmpSecretId: res.data.credentials.tmpSecretId,
			TmpSecretKey: res.data.credentials.tmpSecretKey,
			XCosSecurityToken: res.data.credentials.sessionToken,
			StartTime: res.data.startTime, // 时间戳，单位秒，如：1580000000
			ExpiredTime: res.data.expiredTime // 时间戳，单位秒，如：1580000900
		});
	}
});
/* 图片预览 */
export function getImageUrl(key, callback, sign = true) {
	cos.getObjectUrl(
			{
				Bucket: defaultBucket,
				Region: defaultRegion,
				Key: key,
				Sign: sign, // 是否需要签名
				Expires: 10000 // 单位毫秒
			},
			async (err, data) => {
				if (err) {
					console.log("预览文件失败,请联系管理员")
				} else {
					let url = data.Url;
					// 图片预览url
					let downloadUrl = url + (url.indexOf("?") > -1 ? "&" : "?");
					callback(downloadUrl);
				}
			}
	);
}
/* 判断是否是http链接 */
export function isHttp(url) {
	return url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1
}
